var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHelpIcon = function SvgHelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.763 14H18V2H2v13.385L3.763 14Zm.692 2L0 19.5V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4.455ZM9 11h2v2H9v-2ZM6.567 5.813A3.501 3.501 0 1 1 10 10H9V8h1a1.5 1.5 0 1 0-1.471-1.794l-1.962-.393Z"
  })));
};
export default SvgHelpIcon;